import { Loader } from '..'
import styles from './styles.module.scss'

interface Props {
  label: string
  isUrl?: boolean
  url?: string
  id?: string
  customStyles?: React.CSSProperties
  type?: "submit" | "reset" | "button" | undefined
  onClick?: (e?: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void
  loading?: boolean
  ariaLabel?: string
  disabled?: boolean
}

const Button = (props: Props) => {
  const { id, onClick, label, isUrl, url, customStyles, type, loading, ariaLabel, disabled } = props

  if (isUrl) {
    return (
      <a
        id={id}
        style={customStyles || {}}
        className={styles.buttonWrapper}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={ariaLabel || label}
        onClick={onClick}
      >
        {label}
      </a>
    )
  }
  return (
    <button
      onClick={onClick}
      type={type || 'button'}
      id={id}
      disabled={disabled || loading}
      aria-busy={loading}
      aria-label={ariaLabel || (typeof label === 'string' ? label : undefined)}
      className={styles.buttonWrapper}
      style={customStyles || {}}
    >
      {loading ? <Loader inline /> : label}
    </button>
  )
}

export default Button
